import {createStyles, Theme} from "@material-ui/core";
import {greyInput} from "src/main.style";
import {EditEventStyle} from "@components/calendar2/eventdetails/EditEvent.style";

// Built from the event form's pieces so both edit dialogs look the same.
export const EditTodoStyle = (theme: Theme) => {
  const event = EditEventStyle(theme);
  return createStyles({
    greyInput: event.greyInput,
    buttonOutlinedLarge: event.buttonOutlinedLarge,
    buttonContainedLarge: event.buttonContainedLarge,
    // Sized by their rows; the event form's sections fill a scrolling pane instead.
    section: {
      ...event.section,
      flex: 'none',
    },
    // As tall as a grey input, so rows with only icons are spaced like the event form's.
    row: {
      ...event.row,
      minHeight: '34px',
    },
    leftColumn: {
      ...event.leftColumn,
      justifyContent: 'center',
    },
    rightColumn: {
      ...event.rightColumn,
      alignItems: 'center',
      minWidth: 0,
    },
    fullwidth: event.fullwidth,
    fullwidthInput: {
      ...event.fullwidthInput,
      minWidth: 0,
    },
    greyIcon: event.greyIcon,
    greyBackgroundIcon: event.greyBackgroundIcon,
    pane: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
    },
    // A grey input that opens a menu or picker.
    greyField: {
      ...greyInput,
      flex: 1,
      minWidth: 0,
      justifyContent: 'space-between',
      textTransform: 'none',
      letterSpacing: 0,
      color: theme.palette.common.black,
      '&:hover': {
        backgroundColor: greyInput.backgroundColor,
      },
    },
    greyFieldLabel: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontSize: greyInput.fontSize,
      fontWeight: greyInput.fontWeight,
      lineHeight: greyInput.lineHeight,
    },
    // A whole row that opens a menu, looking like a plain row.
    // Doubled to win over the shared button's padding and centring.
    rowButton: {
      '&&': {
        width: '100%',
        minWidth: 0,
        minHeight: '34px',
        padding: 0,
        borderRadius: '3px',
        justifyContent: 'flex-start',
        textTransform: 'none',
        letterSpacing: 0,
        textAlign: 'left',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        lineHeight: 'inherit',
        color: 'inherit',
      },
    },
    rowButtonLabel: {
      '&&': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: '100%',
        gap: 0,
        textAlign: 'left',
      },
    },
    peopleLabel: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginRight: '12px',
    },
    avatarStack: {
      display: 'flex',
    },
    menuPerson: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    },
    actionsRow: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: '12px',
      paddingTop: '12px',
    },
  });
};



// WEBPACK FOOTER //
// ./src/components/todo/EditTodo.style.ts